/**
 * /claim — the tokenless landing for a postcard or DemoBar claim (fnd-k1d.4).
 *
 * `GET /api/claim/:slug` used to 302 straight to `/invite/<inviteToken>`, which
 * put that business's sole account credential in a Location header any
 * anonymous `curl -sI` could read. It now sets a short-lived HttpOnly handoff
 * cookie on the API origin and redirects here with nothing in the URL. The
 * page below is the same invite experience, reading the invite through
 * `/api/invite/me` — which resolves the cookie server-side — so the browser
 * never holds the token at all.
 *
 * The `/api/claim/:slug` URL shape is deliberately untouched: postcards are
 * already printed and DemoBar is baked into static bundles on R2.
 */
import React from 'react';
import InvitePage from './InvitePage';

const ClaimPage: React.FC = () => <InvitePage claimMode />;

export default ClaimPage;
